<div class="title"  [ngClass]="isDialog ? 'is-pii-shield-dialog' : '' ">
    <div *ngIf="showErrorIcon && headerText" [ngClass]="showErrorIcon ? 'pii-shield-required-attributes-error' : ''">
        <mat-icon>error</mat-icon>
        <span>
            {{headerText}}
        </span>
    </div>

    <ul class="target-list">
        <li *ngFor="let attributeEntity of attributesList; let entityIndex = index">
            <fa-icon icon="{{attributeEntity?.sourceType | ngcEntityIcon}}" class="entity-icon pr-4"></fa-icon>
            <span class="entity-item-name">{{attributeEntity?.sourceType | ngcEntityName}}: </span>

            <span *ngFor="let attribute of attributeEntity?.attributes; let attributeIndex = index">
                <span [class]="attributeStyleClass">{{attribute?.friendlyName}}</span>
                <ng-container *ngIf="attributeIndex < attributeEntity?.attributes?.length - 1">, </ng-container>
            </span>.
        </li>
    </ul>
</div>
